import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDiscover = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 63,
	height: 40,
	viewBox: "0 0 63 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0.5 7.16418C0.5 3.48365 3.48365 0.5 7.16418 0.5H54.9254C58.6059 0.5 61.5896 3.48365 61.5896 7.16418V32.8358C61.5896 36.5163 58.6059 39.5 54.9254 39.5H7.16418C3.48366 39.5 0.5 36.5163 0.5 32.8358V7.16418Z",
			fill: "url(#paint0_linear_8465_83118)",
			stroke: "#D6DCE5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.59668 6.86663C0.59668 3.56941 3.26961 0.896484 6.56683 0.896484H39.1041C49.6553 0.896484 58.2086 9.44985 58.2086 20.001C58.2086 30.5521 49.6553 39.1054 39.1041 39.1054H6.56683C3.26961 39.1054 0.59668 36.4325 0.59668 33.1353V6.86663Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.6551 20.0254C19.6551 22.3744 21.4999 24.1954 23.8728 24.1954C24.5442 24.1954 25.118 24.063 25.8268 23.73V21.8954C25.2039 22.5183 24.652 22.7701 23.9451 22.7701C22.3752 22.7701 21.2611 21.632 21.2611 20.0138C21.2611 18.48 22.4114 17.2697 23.8728 17.2697C24.6165 17.2697 25.1793 17.5343 25.8268 18.1682V16.3343C25.1432 15.9877 24.5803 15.8438 23.9096 15.8438C21.5483 15.8438 19.6551 17.7022 19.6551 20.0254Z",
			fill: "#251F1F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.6548 18.085C15.6548 18.5162 15.9298 18.7447 16.8651 19.0907C18.6384 19.7394 19.1638 20.3139 19.1638 21.5836C19.1638 23.1303 18.0271 24.207 16.4075 24.207C15.2217 24.207 14.3593 23.7403 13.6408 22.6862L14.6478 21.7166C15.0067 22.4105 15.6057 22.7823 16.3487 22.7823C17.0446 22.7823 17.5591 22.3027 17.5591 21.6553C17.5591 21.3196 17.4028 21.0311 17.0917 20.8284C16.9348 20.7322 16.6244 20.5883 16.0143 20.3733C14.5503 19.8466 14.0481 19.283 14.0481 18.1818C14.0481 16.874 15.1268 15.8922 16.5404 15.8922C17.4164 15.8922 18.2181 16.1917 18.8888 16.7784L18.0729 17.8461C17.6669 17.391 17.2834 17.1987 16.8161 17.1987C16.1441 17.1987 15.6548 17.5815 15.6548 18.085Z",
			fill: "#251F1F"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.48853 16.0245H4.2002V24.0153H6.47627C7.68596 24.0153 8.56063 23.73 9.3275 23.0929C10.239 22.3382 10.778 21.2009 10.778 20.0254C10.778 17.6673 9.01571 16.0245 6.48853 16.0245ZM8.30888 22.0278C7.81893 22.4693 7.18311 22.6623 6.17611 22.6623H5.75782V17.3788H6.17611C7.18311 17.3788 7.79376 17.5582 8.30888 18.0249C8.84853 18.5046 9.17193 19.2482 9.17193 20.0138C9.17193 20.7806 8.84853 21.5481 8.30888 22.0278Z",
			fill: "#251F1F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.0541 16.0245H11.4951V24.0153H13.0541V16.0245Z",
			fill: "#251F1F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.0543 16.0245L38.1858 21.3913L40.3444 16.0245H42.0337L38.5815 24.2206H37.7429L34.3521 16.0245H36.0543Z",
			fill: "#251F1F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42.7385 24.0153H47.159V22.6623H44.2962V20.5056H47.0531V19.152H44.2962V17.3788H47.159V16.0245H42.7385V24.0153Z",
			fill: "#251F1F"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M50.5021 16.0245C52.2999 16.0245 53.3314 16.8876 53.3314 18.3832C53.3314 19.6071 52.6839 20.4101 51.5097 20.6489L54.0253 24.0153H52.1088L49.9515 20.8052H49.7475V24.0153H48.1912V16.0245H50.5021ZM49.7475 19.7033H50.2039C51.1993 19.7033 51.7266 19.2708 51.7266 18.4678C51.7266 17.6899 51.1993 17.2826 50.2278 17.2826H49.7475V19.7033Z",
			fill: "#251F1F"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M54.5734 16.4434C54.5734 16.3027 54.4759 16.2259 54.3061 16.2259H54.0802V16.9308H54.248V16.6578L54.4449 16.9308H54.6508L54.4191 16.6403C54.5179 16.6132 54.5734 16.5409 54.5734 16.4434ZM54.2764 16.5396H54.248V16.355H54.2784C54.3616 16.355 54.4049 16.3854 54.4049 16.446C54.4049 16.508 54.361 16.5396 54.2764 16.5396Z",
			fill: "#251F1F"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M53.7258 16.577C53.7258 16.2356 53.9982 15.9625 54.3397 15.9625C54.6728 15.9625 54.9465 16.2407 54.9465 16.577C54.9465 16.9153 54.6728 17.1916 54.3397 17.1916C54.0008 17.1916 53.7258 16.9179 53.7258 16.577ZM53.8478 16.5777C53.8478 16.8578 54.0679 17.0818 54.3371 17.0818C54.6056 17.0818 54.8238 16.8553 54.8238 16.5777C54.8238 16.3027 54.6056 16.0729 54.3371 16.0729C54.066 16.0729 53.8478 16.2975 53.8478 16.5777Z",
			fill: "#251F1F"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_i_8465_83118)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M30.5516 24.2574C28.2162 24.2574 26.3223 22.3635 26.3223 20.0281V20.0223C26.3223 18.8603 26.7928 17.8031 27.5538 17.042C27.5538 17.0362 27.5597 17.0362 27.5597 17.0304C27.5655 17.0304 27.5655 17.0245 27.5713 17.0245C28.3324 16.2635 29.3898 15.793 30.5516 15.793H30.5575C32.893 15.793 34.7869 17.6869 34.7869 20.0223V20.0281C34.7869 21.1901 34.3162 22.2416 33.5552 23.0085C33.5552 23.0143 33.5494 23.0143 33.5494 23.0201C33.5436 23.0201 33.5436 23.0259 33.5378 23.0259C32.7709 23.7869 31.7194 24.2574 30.5575 24.2574H30.5516Z",
				fill: "url(#paint1_linear_8465_83118)"
			})
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_i_8465_83118",
				x: 26.3223,
				y: 15.793,
				width: 9.50283,
				height: 10.0218,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 1.03798,
						dy: 1.55697
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.03798 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "shape",
						result: "effect1_innerShadow_8465_83118"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_8465_83118",
				x1: 19.5338,
				y1: -62759e-10,
				x2: 43.4728,
				y2: 40.5109,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#E05026" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#F9A020"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_8465_83118",
				x1: 28.3363,
				y1: 15.793,
				x2: 35.2914,
				y2: 21.6783,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#EF3823" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .489583,
						stopColor: "#F04D22"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#F7911D"
					})
				]
			})
		] })
	]
});
export default SvgDiscover;
